import { render, staticRenderFns } from "./ThreadList.vue?vue&type=template&id=39bd419e&scoped=true&"
import script from "./ThreadList.vue?vue&type=script&lang=js&"
export * from "./ThreadList.vue?vue&type=script&lang=js&"
import style0 from "./ThreadList.vue?vue&type=style&index=0&id=39bd419e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd419e",
  null
  
)

export default component.exports